import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import ModalContainer from "../modalContainer/modalContainer";
import * as actions from "../../actions";
import { parseApplications } from "../../constants/parse/application";
import Table from "../table/table";
import StatusMessage from "../statusMessage/statusMessage";
import "./subscribeModal.css";
import SubscribeModalRow from "./subscribeModalRow";
import FaSpinner from "../faSpinner/faSpinner";

function SubscribeModal(props) {
  const [selectedAppForSubscribe, setSelectedAppForSubscribe] =
    useState(undefined);

  const {
    modalIsOpen,
    closeModal,
    applications,
    apiProductUuid,
    subscribeApiProductToApplication,
    unsubscribeFromApiProduct,
    subscribeErrorMessage,
    fetchApplicationsByOrganization,
    clearSubscribeErrorMessage,
    loading,
  } = props;

  useEffect(() => {
    // Fetch all applications from all organizations when modal opens
    if (modalIsOpen && fetchApplicationsByOrganization) {
      fetchApplicationsByOrganization();
    }
  }, [modalIsOpen]);

  const onAppSelectHandler = (uuid) => {
    setSelectedAppForSubscribe(uuid);
  };

  return (
    <ModalContainer
      isOpen={modalIsOpen}
      closeModal={closeModal}
      contentLabel="Subscribe Modal"
      title="Subscribe"
    >
      {/* Shown above the list: with many applications the list scrolls and a message below it stays out of view */}
      {subscribeErrorMessage && (
        <div style={{ marginTop: 8 }}>
          <StatusMessage modifiers={[StatusMessage.ERROR]}>
            {subscribeErrorMessage}
          </StatusMessage>
        </div>
      )}
      <div style={{ marginTop: 8 }}>
        {loading ? (
          <FaSpinner loading={true} />
        ) : (
          <Table
            className="subscribe-popup-table"
            hideFooter
            header={[
              {
                title: "Name",
              },
              {
                title: "Organization",
              },
              {
                title: "Environment",
              },
              {
                title: "Status",
              },
            ]}
            rows={applications}
            rowProps={{
              apiProductUuid,
              subscribeApiProductToApplication,
              unsubscribeFromApiProduct,
              selectedAppForSubscribe,
              onAppSelectHandler,
              clearSubscribeErrorMessage,
            }}
            cellsNumber={3}
            RenderRow={SubscribeModalRow}
          />
        )}
      </div>
    </ModalContainer>
  );
}

const mapStateToProps = (state) => ({
  applications: parseApplications(state.application.applicationsById),
  loading: state.application.loading,
  subscribeErrorMessage: state.apiProduct?.subscribeErrorMessage,
});

const mapDispatchToProps = (dispatch) => ({
  fetchApplicationsByOrganization: () => {
    dispatch(actions.fetchApplicationsByOrganization());
  },
  subscribeApiProductToApplication: (payload) => {
    dispatch(actions.subscribeApiProductToApplication(payload));
  },
  unsubscribeFromApiProduct: (payload) => {
    dispatch(actions.unsubscribeFromApiProduct(payload));
  },
  clearSubscribeErrorMessage: () => {
    dispatch(actions.clearSubscribeErrorMessage());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SubscribeModal);
